import React, { useState, useEffect } from "react";
import Drawer from "@mui/material/Drawer";
import {
    TextField,
    Button,
    FormControl,
    Autocomplete,
    FormControlLabel,
    RadioGroup,
    Radio,
    FormLabel

} from "@mui/material";

import { useFormik } from "formik";
import * as Yup from "yup";
import { getUserList } from "../../../api/casp/user";
import { toast } from "react-toastify";
import { AcceptFileType, AcceptProjectLogoType, Action } from "../../../constants/Common";
import SearchDropDownListPaginationComponent from "../common/SearchDropDownPaginationList";
import { withTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';
import { Spinner } from "reactstrap";
import { Role } from "../../../constants/Role";
import { ProjectStatuses, TechnologySector } from "../../../constants/Status";
import { createProject, getProjectDetails, updateProject } from "../../../api/casp/project";
import { useSelector } from "react-redux";
// import AttachFile from '@material-ui/icons/AttachFile';
import { deleteDocument, documentList, uploadFile, uploadLogo } from "../../../api/casp/document";
import { DocumentModule, Modules } from "../../../constants/Module";
import Loader from "../../Common/Loader";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { getUrl } from "../../../helpers/file_helper";
import SweetAlert from "react-bootstrap-sweetalert";
// import { makeStyles } from "@material-ui/core";
import DocumentFilePreviewModal from "../common/DocumentFilePreviewModal";
import { City, Country, State } from "country-state-city";
// import { Clear } from "@material-ui/icons";
import { AttachFile, Clear } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import CurrencyInput from "react-currency-input-field";
import { NumericFormat } from "react-number-format";
import { getAllPortfolios } from "../../../api/casp/portfolio";
const useStyles = makeStyles({
    blueIcon: {
        color: '#296ced',
        cursor: 'pointer'
    },
})


const AddProjectDrawer = ({ isOpen, handleClose, action, selectedProjectRow, t }) => {
    const [projectCreationLoading, setProjectCreationLoading] = useState(false);
    const loggedInUser = useSelector((state) => state.Profile.user);
    const [loadingDocument, setLoadingDocument] = useState(false);
    const [update, setUpdate] = useState(0)
    const [documentUploadType, setDocumentUploadType] = useState()
    const [logoLoader, setLogoLoader] = useState();
    const [presentationDocsLoader, setPresentationLoader] = useState(false)
    const [projectStatus, setProjectStatus] = useState(false);
    const [projectStatusData, setProjectStatusData] = useState(false);
    const [file, setFile] = useState();
    const [filePath, setFilePath] = useState('');
    const [fileName, setFileName] = useState('');
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [modal, setModal] = useState(false);
    const [isReadable, setIsReadable] = useState(false)
    const classes = useStyles();
    const isSpecificCompany = ['NTDP', "JST",'RCT', 'Seu'].includes(loggedInUser?.company?.name)
    const { projectUser } = useSelector((state) => ({
        projectUser: state.projectUser.projectUser,
    }));
    const isShow = loggedInUser?.company?.name ? (isSpecificCompany && action === Action.VIEW ? true : projectUser?.role?.name === Role.PROJECT_MANAGER) : false
    const [excludeFilterIds, setExcludeFilterIds] = useState([{
        name: 'projectAdminId',
        value: []
    },
    {
        name: 'projectOwnerId',
        value: []
    },
    {
        name: 'projectSponsorId',
        value: []
    }]);
    const projectObject = {
        name: "",
        description: "",
        // scope: "",
        projectCost: 150000,
        portfolios: {},
        // projectAdmin: {},
        projectOwner: {},
        projectSponsor: {},
        country: "",
        state: "",
        city: "",
        technologyType: "",
        sector: '',
        logo: '',
        documents: [],
        isRegister: '',
        pendingIps: '',
        grantedIps: '',
        customers: '',
        isPotentialCustomer: '',
        isTRL: '',
        salePlatform: '',
        planRevenue: '',
        isApproval: '',
        analysis: '',
        investors: '',
        isInvestor: '',
        fundStage: '',
        invesmentAmount: '',
        progressDesc: '',
        upcomingDesc: '',
        marketSize: '',
        revenue: '',
        valuation: '',
        jobs: '',
        isOtherPotential: '',
        analysisOther: '',
        presentationDocs: '',
    }

    const projectBasicFieldValidation = Yup.object().shape({
        name: Yup.string()
            .strict(true)
            .trim(t('Must not include leading and trailing spaces'))
            .max(250, t("Too Long!"))
            .matches(/^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]*$/, t("Name should be in proper type"))
            .required(t("Please enter startup name")),
        description: Yup.string()
            .max(2000, t("Too Long!"))
            .strict(true)
            .trim(t('Must not include leading and trailing spaces'))
            .required(t("Please enter description")),

        // scope: Yup.string()
        //     .max(2000, t("Too Long!"))
        //     .strict(true)
        //     .trim(t('Must not include leading and trailing spaces')),
        portfolios: Yup.object().required(t("Please select cohort")),
        // projectAdmin: Yup.object().required(t("Please select founder"))
        // .notOneOf([Yup.ref("projectOwner.id"), Yup.ref('projectSponsor.id')], t("Must be a different founder id")),
        ...(!isSpecificCompany && {
            projectOwner: Yup.object().required("Please select startup owner")
                .notOneOf([Yup.ref("projectAdmin.id"), Yup.ref('projectSponsor.id')], t("Must be a different startup owner id")),
            projectSponsor: Yup.object().required()
                .notOneOf([Yup.ref("projectOwner.id"), Yup.ref('projectAdmin.id')], t("Must be a different startup owner id")),
            technologyType: Yup.string()
                .trim(t('Must not include leading and trailing spaces'))
        }),
        projectCost: Yup.number()
            .strict(true)
            .min(0),
        country: Yup.object()
            .required(t("Please Enter country")),
        state: Yup.object().optional().nullable(),
        city: Yup.object().optional().nullable(),
    })

    const regMatch = /^(https|https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-]*)*$/;
    const projectValidation = Yup.object().shape({
        name: Yup.string()
            .strict(true)
            .trim(t('Must not include leading and trailing spaces'))
            .max(250, t("Too Long!"))
            .matches(/^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]*$/, t("Name should be in proper type"))
            .required(t("Please enter startup name")),
        description: Yup.string()
            .max(2000, t("Too Long!"))
            .strict(true)
            .trim(t('Must not include leading and trailing spaces'))
            .required(t("Please enter description")),
        // scope: Yup.string()
        //     .max(2000, t("Too Long!"))
        //     .strict(true)
        //     .trim(t('Must not include leading and trailing spaces')),
        portfolios: Yup.object().required(t("Please select cohort")),
        // projectAdmin: Yup.object().required(t("Please select founder"))
        //     .notOneOf([Yup.ref("projectOwner.id"), Yup.ref('projectSponsor.id')], t("Must be a different founder id")),
        projectCost: Yup.number()
            .strict(true)
            .min(0),
        country: Yup.object()
            .required(t("Please Enter country")),
        state: Yup.object().optional().nullable(),
        city: Yup.object().optional().nullable(),
        sector: Yup.string().required(t('Please select technology sector')),
        technologyType: Yup.string().required(t('Please select technology type')),
        documents: Yup.array().max(5, t('You are only allowed to upload 5 documents for startup.')).optional(),
        fileSize: Yup.number().min(0, t('File Size less than 0 Byte')).max(1024 * 1024 * 10, t('File Size must be less than or equal to 10MB')),
        fileFormat: Yup.mixed().test('fileFormat', t('Invalid file format (.exe file not allowed)'), (value) => {
            if (!value) return true;
            return !['application/x-ms-dos-executable'].includes(value.type);
        }),
        // isRegister: Yup.string().required('Please select official status of the startup'),
        pendingIps: Yup.number().optional(),
        grantedIps: Yup.number().optional(),
        customers: Yup.string().optional(),
        isPotentialCustomer: Yup.string().required(t('Please potential customers is available or not?')),
        isTRL: Yup.string().required(t("Please select, where does your startup stand")),
        // salePlatform: Yup.string().matches(regMatch,'Please enter valid url').optional(),
        // marketSize: Yup.string().optional(),
        isApproval: Yup.string().optional(),
        // isInvestor: Yup.string().required('Please select currently raising fund for investments is available or not'),
        // analysis: Yup.string().required("Please select conducted financial analysis or projections"),
        // invesmentAmount: Yup.number().optional(),
        // progressDesc: Yup.string()
        //     .max(2000, t("Too Long!"))
        //     .strict(true)
        //     .trim(t('Must not include leading and trailing spaces')),
        // upcomingDesc: Yup.string()
        //     .max(2000, t("Too Long!"))
        //     .strict(true)
        //     .trim(t('Must not include leading and trailing spaces')),
        isOtherPotential: Yup.string().when("isPotentialCustomer", {
            is: 'other',
            then: Yup.string().required(t('Please enter potential customer'))
        }),
        presentationDocs:Yup.object().required(t("Please select pitch deck attachment")),
        // analysisOther: Yup.string().when("analysis", {
        //     is: 'other',
        //     then: Yup.string().required('Please enter analysis other')
        // })
    });

    const formik = useFormik({
        initialValues: {
            ...projectObject,
        },
        validationSchema: isShow ? projectValidation : projectBasicFieldValidation,
        validateOnMount: true,
    });

    useEffect(() => {
        if (selectedProjectRow !== undefined && [Action.EDIT, Action.VIEW].includes(action)) {
            fetchProjectDetails(selectedProjectRow.id);
            setIsReadable(action === Action.VIEW)
            isShow && getDocumentList()
        }
    }, [selectedProjectRow])

    const fetchCountryDetails = (countryName) => {
        const countries = Country.getAllCountries();
        const country = countries.find(country => country?.name?.toLowerCase() === countryName?.toLowerCase());

        if (country) {
            return country
        }
    };
    const fetchStateDetails = (stateName) => {
        const states = State.getAllStates();
        const state = states.find(state => state?.name?.toLowerCase() === stateName?.toLowerCase());

        if (state) {
            return state
        }
    };

    const fetchProjectDetails = async (projectId) => {
        try {
            setProjectCreationLoading(true);
            const res = (await getProjectDetails(projectId)).data.data;
            setProjectStatusData(res.status)
            if (res.status === ProjectStatuses.DRAFT || res.status === ProjectStatuses.REJECTED) {
                setProjectStatus(true);
            }

            formik.setValues({
                ...formik.values,
                name: res.name,
                description: res.description ? res.description : '',
                // scope: res?.scope ? res?.scope : '',
                projectCost: projectObject.projectCost,
                // projectAdmin: {
                //     id: res?.projectAdmin?.id,
                //     label: res?.projectAdmin?.name,
                //     key: `${res?.projectAdmin?.id}|${res?.projectAdmin?.name}`
                // },
                projectSponsor: {
                    id: res?.projectSponsor?.id,
                    label: res?.projectSponsor?.name,
                    key: `${res?.projectSponsor?.id}|${res?.projectSponsor?.name}`
                },
                portfolios: {
                    id: res?.portfolio?.id,
                    label: res?.portfolio?.name,
                    key: `${res?.portfolio?.id}|${res?.portfolio?.name}`
                },
                // portfolios: {
                //     id: res?.portfolioProjects[0]?.portfolio.id,
                //     label: res?.portfolioProjects[0]?.portfolio.name,
                //     key: `${res?.portfolioProjects[0]?.portfolio.id}|${res?.portfolioProjects[0].portfolio.name}`
                // },
                projectOwner: {
                    id: res?.projectOwner?.id,
                    label: res?.projectOwner?.name,
                    key: `${res?.projectOwner?.id}|${res?.projectOwner?.name}`
                },
                country: fetchCountryDetails(res.country),
                state: res.state ? fetchStateDetails(res.state) : "",
                city: res.city ? res.city : "",
                technologyType: res.technologyType,
                sector: res.sector ?? '',
                logo: res.logo ?? '',
                presentationDocs: res?.document ?? '',
                isRegister: res.isRegister ?? '',
                pendingIps: res.pendingIps ?? '',
                grantedIps: res.grantedIps ?? '',
                valuation: res.valuation === 0 ? '' : res.valuation,
                jobs: res.jobs === 0 ? '' : res.jobs,
                customers: res.customers ?? '',
                isPotentialCustomer: res.isPotentialCustomer ?? '',
                isTRL: res.isTRL ?? '',
                salePlatform: res.salePlatform ?? '',
                planRevenue: res.planRevenue ?? '',
                isApproval: res.isApproval ?? '',
                analysis: res.analysis ?? '',
                investors: res.investors ?? '',
                isInvestor: res.isInvestor ?? '',
                fundStage: res.fundStage ?? '',
                invesmentAmount: res.invesmentAmount ?? '',
                progressDesc: res.progressDesc ?? '',
                upcomingDesc: res.upcomingDesc ?? '',
                marketSize: res.marketSize ?? '',
                revenue: res.revenue === 0 ? '' : res.revenue,
                isOtherPotential: res?.isOtherPotential ?? '',
                analysisOther: res?.analysisOther ?? ''
            })
            setUpdate(update + 1)
        } catch (error) {
            toast.error(error.message)
        } finally {
            setProjectCreationLoading(false)
        }
    }

    const handleCreate = async () => {
        try {
            setProjectCreationLoading(true);
            const payload = {
                name: formik.values.name,
                description: formik.values.description ? formik.values.description : '',
                // scope: formik.values.scope ? formik.values.scope : '',
                companyId: loggedInUser?.company?.id,
                isCoreCompany: isShow,
                isHideColumn: isSpecificCompany,
                portfolioId: formik.values.portfolios.id,
                // ...(!isSpecificCompany && {
                // projectOwnerId: formik.values.projectOwner.id,
                // projectSponsorId: formik.values.projectSponsor.id,
                technologyType: formik.values.technologyType ? formik.values.technologyType : '',
                // }),
                // projectAdminId: formik.values.projectAdmin.id,
                projectCost: projectObject.projectCost,
                country: formik.values.country.name,
                ...(formik.values.state?.name && {
                    state: formik.values.state.name
                }),
                ...(formik.values.city?.name && {
                    city: formik.values.city.name
                })
            };

            const response = await createProject(payload);
            let isFile = false
            let isChecked = false
            if (response.statusCode === 200) {

                if (isShow) {
                    if (formik.values.logo) {
                        const formData = new FormData();
                        formData.append('logo', formik.values.logo);
                        formData.append('moduleId', response.data.data.id);
                        formData.append('module', Modules.PROJECT);
                        formData.append('updateField', 'logo')
                        const result = (await uploadLogo(formData)).data.data;
                        isFile = true
                    }

                    if (formik.values.presentationDocs) {
                        const formData = new FormData();
                        formData.append('logo', formik.values.presentationDocs);
                        formData.append('moduleId', response.data.data.id);
                        formData.append('module', Modules.PROJECT);
                        formData.append('updateField', 'document')
                        const result = (await uploadLogo(formData)).data.data;
                        isFile = true
                    }

                    if (formik?.values?.documents?.length > 0) {
                        const formData = new FormData();
                        for (let i = 0; i < formik?.values?.documents.length; i++) {
                            formData.append('files', formik?.values?.documents[i]);
                        }
                        formData.append('moduleId', response.data.data.id);
                        formData.append('module', Modules.PROJECT);
                        formData.append('projectId', response.data.data.id);
                        const result = (await uploadFile(formData)).data.data;
                        isFile = true
                        toast.success(response.data.message);
                        handleCancel('success');
                    } else {
                        isChecked = true
                        if (((formik.values.logo && formik.values.presentationDocs) || (formik.values.logo && !formik.values.presentationDocs) || (!formik.values.logo && formik.values.presentationDocs)) ? isFile : true) {
                            toast.success(response.data.message);
                            handleCancel('success');
                        }
                    }
                    if (!formik.values.logo && !formik.values.presentationDocs && !formik.values?.documents?.length === 0) {
                        toast.success(response.data.message)
                        handleCancel('success');
                    }
                } else {
                    toast.success(response.data.message)
                    handleCancel('success');
                }

            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setProjectCreationLoading(false);
            setExcludeFilterIds([{
                name: 'projectAdminId',
                value: []
            },
                // {
                //     name: 'projectOwnerId',
                //     value: []
                // },
                // {
                //     name: 'projectSponsorId',
                //     value: []
                // }
            ])
        }
    };

    const handleLogoUpload = async (file, docType) => {
        try {
            if (file.size >= (1024 * 1024 * 10)) {
                return toast.error('Please upload file size less than 10 MB');
            }
            docType === 'logo' ? setLogoLoader(true) : setPresentationLoader(true)
            const formData = new FormData();
            formData.append('logo', file);
            formData.append('moduleId', selectedProjectRow?.id);
            formData.append('module', Modules.PROJECT);
            formData.append('updateField', docType === 'logo' ? docType : 'document')
            const result = (await uploadLogo(formData)).data.data;
            docType === 'logo' ? formik.setFieldValue('logo', result?.logo) : formik.setFieldValue('presentationDocs', result?.document)
        } catch (err) {
            console.log(err)
        } finally {
            docType === 'logo' ? setLogoLoader(false) : setPresentationLoader(false)
        }
    }

    const handleEdit = async () => {
        try {
            setProjectCreationLoading(true);
            const payload = {
                name: formik.values.name,
                description: formik.values.description,
                scope: formik.values.scope,
                companyId: loggedInUser?.company?.id,
                isCoreCompany: isShow,
                isHideColumn: isSpecificCompany,
                portfolioId: formik.values.portfolios.id,
                // projectAdminId: formik.values.projectAdmin.id,
                // projectOwnerId: formik.values.projectOwner.id,
                // projectSponsorId: formik.values.projectSponsor.id,
                projectCost: projectObject.projectCost,
                country: formik.values.country.name,
                state: formik.values.state ? formik.values.state.name : '',
                city: formik.values.city ? formik.values.city.name : '',
                // technologyType: formik.values.technologyType,
                ...(isShow && {
                    sector: formik.values.sector,
                    // isRegister: formik.values.isRegister,
                    pendingIps: formik.values?.pendingIps ? formik.values?.pendingIps.toString() : '',
                    grantedIps: formik.values?.grantedIps ? formik.values?.grantedIps.toString() : '',
                    customers: formik.values?.customers ?? '',
                    technologyType: formik.values.technologyType,
                    isPotentialCustomer: formik.values.isPotentialCustomer,
                    isTRL: formik.values.isTRL,
                    // salePlatform: formik.values?.salePlatform ?? '',
                    // planRevenue: formik.values?.planRevenue ?? '',
                    isApproval: formik.values?.isApproval ?? '',
                    // analysis: formik.values.analysis,
                    // isInvestor: formik.values.isInvestor,
                    // jobs: formik.values.jobs ? formik.values.jobs : 0,
                    // valuation: formik.values.valuation ? formik.values.valuation : 0,
                    fundStage: formik.values?.fundStage ?? '',
                    // investors: formik.values?.investors ?? '',
                    // invesmentAmount: formik.values?.invesmentAmount ? formik.values?.invesmentAmount : '0',
                    // progressDesc: formik.values?.progressDesc ?? '',
                    // upcomingDesc: formik.values?.upcomingDesc ?? '',
                    // marketSize: formik.values?.marketSize ?? '',
                    // revenue: formik.values?.revenue ? formik.values?.revenue : 0,
                    ...((formik.values?.isOtherPotential && formik.values.isPotentialCustomer === 'other') ? {
                        isOtherPotential: formik.values?.isOtherPotential,
                    } : { isOtherPotential: '' }),
                    // ...((formik.values?.analysisOther && formik.values.analysis === 'other') ? {
                    //     analysisOther: formik.values?.analysisOther,
                    // } : { analysisOther: '' })
                })
            };

            const response = await updateProject(payload, selectedProjectRow.id);
            if (response.statusCode === 200) {
                toast.success(response.data.message);
                handleCancel('success');
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setProjectCreationLoading(false);
            setExcludeFilterIds([{
                name: 'projectAdminId',
                value: []
            },
                // {
                //     name: 'projectOwnerId',
                //     value: []
                // },
                // {
                //     name: 'projectSponsorId',
                //     value: []
                // }
            ])
        }
    };

    const handleCancel = (message, reason) => {
        if (reason === 'backdropClick') {
            return;
        } else if (isOpen) {
            formik.resetForm();
            formik.setValues(formik.initialValues);
        }

        handleClose(message);
    };

    const handleFileUpload = async (file, module, itemId = '', itemIndex = '') => {
        try {
            const fileExtension = file ? `.${file.name.split('.').pop().toLowerCase()}` : '';

            if (fileExtension && !AcceptFileType.includes(fileExtension)) {
                file = null;
                return toast.error('Invalid file type');
            }
            if (file.size > (1024 * 1024 * 10)) {
                return toast.error('Payload content length greater than maximum allowed: 10 MB');
            }
            if (formik.values?.documents?.length === 2) {
                return toast.error('You are only allowed to upload 2 documents for agenda');
            }
            setLoadingDocument(true)
            const formData = new FormData();
            formData.append('files', file);
            formData.append('moduleId', selectedProjectRow.id);
            formData.append('module', Modules.PROJECT);
            formData.append('projectId', selectedProjectRow?.id)

            const result = await uploadFile(formData);
            await getDocumentList()
        } catch (error) {
            console.log(error)
        } finally {
            setLoadingDocument(false)
            setUpdate(new Date())
        }
    }

    const handelChange = (event, module = '', docType) => {
        let file = event.target.files[0]
        const fileExtension = file ? `.${file.name.split('.').pop().toLowerCase()}` : '';
        if (file && !AcceptFileType.includes(fileExtension)) {
            file = null;
            return toast.error('Invalid file type')
        }
        if (event.target.files[0].size >= (1024 * 1024 * 10)) {
            return toast.error('Please upload file size less than 10 MB');
        }

        Object.assign(file, {
            ...file,
            location: `${URL.createObjectURL(file)}${fileExtension}`,
        })

        if (module !== Modules.PROJECT) {
            docType === 'logo' ? formik.setFieldValue('logo', file) : formik.setFieldValue('presentationDocs', file)
        } else {
            if (formik.values?.documents?.length === 5) {
                return toast.error('You are only allowed to upload 5 documents for project');
            }

            formik.setFieldValue('documents', formik.values.documents?.length > 0 ? [...formik.values.documents, file] : [file])
            formik.setFieldValue('fileSize', formik.values.fileSize ? formik.values.fileSize + file?.size : file?.size)
            if (event.target.files[0].type === 'application/x-ms-dos-executable')
                formik.setFieldValue('fileFormat', event.target.files[0].type)
        }
    }

    const handelDelete = async () => {
        try {
            setIsOpenSweetAlert(false)
            setLoadingDocument(true)
            const res = await deleteDocument(file?.id)
            toast.success(res.data.message)
            getDocumentList()
            setLoadingDocument(false)
            setDocumentUploadType()
            setFile()
        } catch (err) {
            setLoadingDocument(false)
            setFile()
            toast.error(err.message)
        }
    }

    const removeFile = () => {
        formik.setFieldValue('documents', formik.values?.documents.filter(function (item) {
            return item?.name !== file.name
        }))
        formik.setFieldValue('fileSize', formik.values.fileSize - file.size)
        if (file.type === 'application/x-ms-dos-executable')
            formik.setFieldValue('fileFormat', '')
        setIsOpenSweetAlert(false)
        setDocumentUploadType()
    }

    const getDocumentList = async () => {
        try {
            let params = {
                module: DocumentModule.PROJECT,
                moduleId: selectedProjectRow?.id,
                projectId: selectedProjectRow?.id
            };
            const documentData = await documentList(params)
            formik.setFieldValue('documents', documentData.data.data.data)
        } catch (err) {
            console.log(err)
        }
    }

    return (
        <div>
            <Drawer
                anchor="right"
                key={update}
                open={isOpen}
                onClose={() => handleCancel()}
                PaperProps={{
                    sx: { width: "580px" },
                }}
                className="projectListDrawer"
            >
                <form className="p-3">
                    <h5>{action === undefined ? t('Add Startup') : t(`${action} Startup`)}</h5>
                    <CloseIcon className="crossIcon" onClick={() => handleCancel()} />
                    <div className="row">
                        <div className="col-sm-12 mb-3">
                            <TextField
                                inputProps={{ readOnly: isReadable }}
                                id="outlined-basic"
                                label={t('Startup Name')}
                                variant="outlined"
                                type="text"
                                size="small"
                                name="name"
                                value={formik.values.name}
                                disabled={projectCreationLoading || projectUser?.role?.name === Role.PROJECT_MANAGER}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                onFocus={() => {
                                    if (!formik.touched?.projectName) {
                                        formik.setFieldTouched("projectName", true, true);
                                    }
                                }}
                                fullWidth
                                required
                            />
                            {formik.touched.name && formik.errors.name && (
                                <span className="text-danger">{formik.errors.name}</span>
                            )}
                        </div>
                        {isShow && (
                            <div className="row mb-3">
                                <div
                                    key={update}
                                    className="col-md-6 col-12 fileUpload"
                                    style={{ position: "relative", justifyContent: 'center' }}
                                >
                                    <div className="globalAttachmentBrowse position-relative">
                                        <AttachFile
                                            className="attachment_button"
                                            style={isReadable ? { cursor: 'not-allowed' } : { cursor: 'pointer' }}
                                        />
                                        <span className="mx-2">{t("Upload Startup Logo")}</span>
                                        <input
                                            type="file"
                                            disabled={isReadable}
                                            accept={AcceptProjectLogoType.toString()}
                                            name="logo"
                                            onChange={(e) => {
                                                e.stopPropagation()
                                                e.preventDefault()
                                                selectedProjectRow?.id ? handleLogoUpload(e.target.files[0], 'logo') : handelChange(e, undefined, 'logo')
                                            }}
                                            className="browse_attachment_inpt"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6 col-12  d-grid globalAttachmentList">
                                    {logoLoader && <Loader />}
                                    {formik.values?.logo && (
                                        <>
                                            <div className='singleAttachment'>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div className="attachmentFileIcon">
                                                        <DescriptionOutlinedIcon />
                                                    </div>
                                                    <span className='me-3 fs-6 fw-semibold text-truncate' style={{
                                                        width: '180px', display: 'inline-block'
                                                    }}>{formik.values?.logo?.name} </span>
                                                    <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                                                        setModal(true)
                                                        setFilePath(selectedProjectRow?.id ? getUrl(formik.values.logo.storageLink) : formik.values?.logo?.location)
                                                        setFileName(formik.values?.logo?.name)
                                                    }
                                                    } />
                                                    {/* <DeleteOutlineOutlinedIcon className="mx-2" style={{ cursor: 'pointer' }} onClick={(e) => {
                                                        setFile(file)
                                                        setIsOpenSweetAlert(true);
                                                    }} /> */}
                                                </div>
                                            </div >
                                        </>
                                    )}
                                </div>
                            </div>
                        )}
                        <div className="col-sm-12 mb-3">
                            <TextField
                                fullWidth
                                className="form-control"
                                inputProps={{ readOnly: isReadable }}
                                id="project-title-input"
                                label={t("Description")}
                                name="description"
                                value={formik.values.description}
                                disabled={projectCreationLoading}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                required
                                onFocus={() => {
                                    if (!formik.touched?.description) {
                                        formik.setFieldTouched("description", true, true);
                                    }
                                }}
                                multiline
                                rows={4}
                            />
                            <div>
                                {formik.touched.description && formik.errors.description && (
                                    <span className="text-danger">{formik.errors.description}</span>
                                )}
                            </div>
                        </div>
                        {/* {isShow && (
                            <><div className="row mb-3">
                                <div className="col-md-9 col-12">
                                    <span className="mb-2">{t("Please provide the official Commercial Registration (CR) of the company if it is officially registered.")}</span>
                                </div>
                                <div
                                    key={update}
                                    className="col-md-3 col-12 fileUpload"
                                    style={{ position: "relative", justifyContent: 'center' }}
                                >
                                    <div className="globalAttachmentBrowse position-relative">
                                        <AttachFile
                                            className="attachment_button"
                                            style={isReadable ? { cursor: 'not-allowed' } : { cursor: 'pointer' }} />
                                        <span className="mx-2">{t("Upload")}</span>
                                        <input
                                            type="file"
                                            disabled={isReadable} // {isReadable}
                                            accept={AcceptFileType.toString()}
                                            name="documents"
                                            onChange={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                action === Action.EDIT ? handleFileUpload(e.target.files[0], Modules.PROJECT) : handelChange(e, Modules.PROJECT);
                                            }}
                                            onBlur={() => {
                                                if (formik.touched?.documents?.length > 0 ? !formik.touched?.documents : true) {
                                                    formik.setFieldTouched("documents", true, false);
                                                }
                                                if (!formik.touched?.fileSize) {
                                                    formik.setFieldTouched("fileSize", true, false);
                                                }
                                                if (!formik.touched?.fileFormat) {
                                                    formik.setFieldTouched("fileFormat", true, false);
                                                }
                                            }}
                                            className="browse_attachment_inpt" />
                                    </div>
                                </div>
                            </div><div>
                                    {formik.touched.fileFormat && formik.errors.fileFormat && (
                                        <span className="text-danger"> {formik.errors.fileFormat}</span>
                                    )}
                                </div><div>{formik?.touched?.documents && formik.errors?.documents && (
                                    <span className="text-danger">{formik.errors.documents} </span>
                                )}</div><div className="d-grid globalAttachmentList mb-3">
                                    {loadingDocument && <Loader />}
                                    {formik?.values?.documents?.length > 0 && formik?.values?.documents.map((file, key) => (
                                        <>
                                            <div className='singleAttachment mt-1' key={key}>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div className="attachmentFileIcon">
                                                        <DescriptionOutlinedIcon />
                                                    </div>
                                                    <span className='me-3 fs-6 fw-semibold text-truncate' style={{
                                                        width: '150px', display: 'inline-block'
                                                    }}>{file?.name} </span>
                                                    <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                                                        setModal(true);
                                                        setFilePath(selectedProjectRow?.id ? getUrl(file.storageLink) : file?.location);
                                                        setFileName(file.name);
                                                    }} />
                                                    <DeleteOutlineOutlinedIcon disabled={isReadable} className="mx-2" style={isReadable ? { cursor: 'not-allowed' } : { cursor: 'pointer' }} onClick={(e) => {
                                                        if (!isReadable) {
                                                            setFile(file);
                                                            setDocumentUploadType(Modules.PROJECT);
                                                            setIsOpenSweetAlert(true);
                                                        }
                                                    }} />
                                                </div>
                                            </div>
                                        </>
                                    ))}
                                </div></>
                        )} */}

                        {/* {(action === Action.EDIT ? projectStatus : true) &&
                            <div className="mb-3 mt-2">
                                <TextField
                                    fullWidth
                                    className="form-control"
                                    inputProps={{ readOnly: isReadable }}
                                    id="project-title-input"
                                    placeholder={t("Scope")}
                                    name="scope"
                                    value={formik.values.scope}
                                    disabled={projectCreationLoading}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    onFocus={() => {
                                        if (!formik.touched?.scope) {
                                            formik.setFieldTouched("scope", true, true);
                                        }
                                    }}
                                    multiline
                                    rows={3}
                                />
                                {formik.touched.scope && formik.errors.scope && (
                                    <span className="text-danger">{formik.errors.scope}</span>
                                )}
                            </div>
                        } */}
                        {((action === Action.EDIT ? projectStatus : true) || action === Action.VIEW) &&
                            <div className="col-sm-12 mb-3 plCurrency pe-2">
                                {/* <NumericFormat
                                    minimumValue="0"
                                    variant="outlined"
                                    decimalPlaces={2}
                                    inputProps={{ readOnly: isReadable }}
                                    value={formik.values.projectCost}
                                    prefix="SAR"
                                    fullWidth
                                    placeholder={t("Startup Cost")}
                                    required
                                    disabled={true}
                                    onChange={(e, newValue) => {
                                        formik.setFieldValue('projectCost', newValue === 0 ? '' : newValue, true)
                                    }}
                                    onBlur={() => {
                                        formik.setFieldTouched('projectCost', true, true)
                                    }}
                                /> */}
                                <NumericFormat
                                    customInput={TextField}
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                    prefix="SAR | "
                                    value={formik.values.projectCost}
                                    onValueChange={(values) => {
                                        formik.setFieldValue(
                                        'projectCost',
                                        values.floatValue === 0 ? '' : values.floatValue,
                                        true
                                        );
                                    }}
                                    onBlur={() => {
                                        formik.setFieldTouched('projectCost', true, true);
                                    }}
                                    isNumericString
                                    placeholder={t("Startup Cost")}
                                    fullWidth
                                    variant="outlined"
                                    inputProps={{ readOnly: isReadable }}
                                    disabled={true}
                                />
                                {formik.touched.projectCost && formik.errors.projectCost && (
                                    <span className="text-danger">{formik.errors.projectCost}</span>
                                )}
                            </div>
                        }
                        {/* <div className={`${action === Action.EDIT ? (projectStatus ? 'col-sm-6' : 'col-sm-12') : 'col-sm-6'} mb-3 projectTypeField plSelectTypeField`}>
                            <SearchDropDownListPaginationComponent
                                label={t('Startup Type') + " *"}
                                disabled={projectCreationLoading}
                                readOnly={isReadable}
                                searchEnabled={false}
                                disableClearable={!formik.values.projectType}
                                listCall={getProjectType}
                                defaultValue={Object.keys(formik.values.projectType).length !== 0 ? formik.values.projectType : undefined}
                                size="small"
                                apiParams={{
                                    order: "updatedAt",
                                    direction: "desc",
                                }}
                                emitItem={(newValue) => {
                                    formik.setFieldTouched("projectType", true, true)
                                    formik.setFieldValue(
                                        "projectType",
                                        newValue ? newValue : {}
                                    );
                                }}
                                onBlur={() => {
                                    if (!formik.touched?.projectType) {
                                        formik.setFieldTouched("projectType", true, true);
                                    }
                                }}
                            />
                            {formik.touched.projectType &&
                                formik.errors.projectType && (
                                    <span className="text-danger">
                                        {formik.errors.projectType}
                                    </span>
                                )}
                        </div> */}

                        {/* {(isSpecificCompany ? projectUser?.role?.name === Role.PROJECT_MANAGER : true) && ( */}
                        <div className="col-sm-12 mb-3 plSelectTypeField">
                            <Autocomplete
                                disabled={projectCreationLoading}
                                id="combo-box-demo"
                                sx={{ width: '100%' }}
                                options={["Architectural Technology",
                                    "Entertainment Technology",
                                    "Mechanical Engineering Technology",
                                    "Robotics",
                                    "Agricultural Technology",
                                    "Biotechnology",
                                    "Computers",
                                    "Transport",
                                    "Audiovisual",
                                    "Health Technology",
                                    "Educational Technology",
                                    "Manufacturing Technology",
                                    "Information and Communications Technology",
                                    "Internet of things",
                                    "Artifical Intelligence",
                                    "Electronic Technology",
                                    "Energy Technology",
                                    "Cyber Security",
                                    "Environmental Technology",
                                    "Financial Technology",
                                    "Business Technology",
                                    "Space",
                                    "Aerospace Technology",
                                    "Blockchain"]}
                                    getOptionLabel={(option) => option ? t(option) : ""}
                                name="technologyType"
                                size="small"
                                readOnly={isReadable}
                                value={formik.values?.technologyType}
                                onChange={(e, val) => formik.setFieldValue("technologyType", val)}
                                renderInput={(params) => <TextField {...params} label={action === Action.EDIT || action === Action.VIEW ? t("Technology Type") + ' *' : t("Technology Type")} />}
                                clearIcon={formik.values?.technologyType ? <Clear /> : null}
                                required
                            />
                            {formik.touched.technologyType && formik.errors.technologyType && (
                                <span className="text-danger d-block">
                                    {formik.errors.technologyType}
                                </span>
                            )}
                        </div>
                        {/* )} */}
                        <div className="col-sm-6 mb-3 plSelectTypeField">
                            <Autocomplete
                                disabled={projectCreationLoading}
                                id="combo-box-demo"
                                sx={{ width: '100%' }}
                                readOnly={isReadable}
                                options={Country.getAllCountries()}
                                getOptionLabel={(option) => option.name ? option.name : formik.values.country ? formik.values.country : ""}
                                name="country"
                                size="small"
                                value={formik.values?.country}
                                onChange={(e, val) => {
                                    formik.setFieldValue("country", val)
                                    formik.setFieldValue("state", "")
                                    formik.setFieldValue("city", "")
                                }}
                                renderInput={(params) => <TextField {...params} label={t("Country") + ' *'} />}
                                clearIcon={formik.values?.country ? <Clear /> : null}
                                required
                            />
                            {formik.touched.country && formik.errors.country && (
                                <span className="text-danger d-block">
                                    {formik.errors.country}
                                </span>
                            )}
                        </div>
                        <div className="col-sm-6 mb-3 plSelectTypeField">
                            <Autocomplete
                                disabled={projectCreationLoading}
                                id="combo-box-demo"
                                sx={{ width: '100%' }}
                                options={State.getStatesOfCountry(formik?.values?.country?.isoCode)}
                                getOptionLabel={(option) => option.name ? option.name : formik.values.state ? formik.values.state : ""}
                                name="state"
                                size="small"
                                readOnly={isReadable}
                                value={formik.values?.state}
                                onChange={(e, val) => {
                                    formik.setFieldValue("state", val)
                                    formik.setFieldValue("city", "")
                                }}
                                renderInput={(params) => <TextField {...params} label={t("Enter State")} />}
                                clearIcon={formik.values?.state ? <Clear /> : null}
                            />
                            {formik.touched.state && formik.errors.state && (
                                <span className="text-danger d-block">
                                    {formik.errors.state}
                                </span>
                            )}
                        </div>
                        <div className="mb-3 plSelectTypeField">
                            <Autocomplete
                                disabled={projectCreationLoading}
                                id="combo-box-demo"
                                sx={{ width: '100%' }}
                                readOnly={isReadable}
                                options={City.getCitiesOfState(formik?.values?.state?.countryCode, formik?.values?.state?.isoCode)}
                                getOptionLabel={(option) => option.name ? option.name : formik.values.city ? formik.values.city : ""}
                                name="city"
                                size="small"
                                value={formik.values?.city}
                                onChange={(e, val) => formik.setFieldValue("city", val)}
                                renderInput={(params) => <TextField {...params} label={t("Enter City")} />}
                                clearIcon={formik.values?.city ? <Clear /> : null}
                            />
                            {formik.touched.city && formik.errors.city && (
                                <span className="text-danger d-block">
                                    {formik.errors.city}
                                </span>
                            )}
                        </div>
                        {projectStatusData !== ProjectStatuses.ONGOING &&
                        <div className="mb-3 plSelectTypeField">
                            <SearchDropDownListPaginationComponent
                                label={t("Cohort") + " *"}
                                disabled={projectCreationLoading}
                                searchEnabled={false}
                                readOnly={isReadable}
                                listCall={getAllPortfolios}
                                disableClearable={!formik.values.portfolios}
                                defaultValue={Object.keys(formik.values.portfolios).length !== 0 ? formik.values.portfolios : undefined}
                                apiParams={{
                                    order: "updatedAt",
                                    direction: "desc",
                                    ...(![
                                        Role.PROJECT_MANAGER,
                                        Role.EPMO_MANAGER,
                                        Role.ROOT_ADMIN,
                                        Role.VICE_PRESIDENT,
                                        Role.PRESIDENT,
                                        Role.PROGRAM_MANAGER,
                                        Role.EPMO_OFFICER,
                                    ].includes(loggedInUser?.role?.name) && {
                                        filterFields: "portfolioUser",
                                        filterInputs: loggedInUser.id,
                                    }),
                                }}
                                emitItem={(newValue) => {
                                    formik.setFieldTouched("portfolios", true, true);
                                    formik.setFieldValue(
                                        "portfolios",
                                        newValue ? newValue : {}
                                    );
                                }}
                                onBlur={() => {
                                    if (!formik.touched?.portfolios) {
                                        formik.setFieldTouched("portfolios", true, true);
                                    }
                                }}
                            />
                            {formik.touched.portfolios && formik.errors.portfolios && (
                                <span className="text-danger">
                                    {formik.errors.portfolios}
                                </span>
                            )}
                        </div>
                        }
                        {/* <div className="mb-3 plSelectTypeField">
                            <SearchDropDownListPaginationComponent
                                label={t("Founder") + " *"}
                                disabled={projectCreationLoading || isShow}
                                searchEnabled={false}
                                readOnly={isReadable}
                                defaultValue={Object.keys(formik.values.projectAdmin).length !== 0 ? formik.values.projectAdmin : undefined}
                                disableClearable={!formik.values.projectAdmin}
                                listCall={getUserList}
                                apiParams={{
                                    order: "firstName",
                                    direction: "desc",
                                    isActive: true,
                                    includeAdmins: false,
                                    ...(excludeFilterIds.find((ex) => ex.name === 'projectAdminId')?.value?.length !== 0 && {
                                        excludeFilterFields: "id",
                                        excludeFilterInputs: excludeFilterIds.find((ex) => ex.name === 'projectAdminId')?.value?.join(',')
                                    })
                                }}
                                emitItem={(newValue) => {
                                    const oldProjectAdminId = formik.values.projectAdmin.id
                                    formik.setFieldTouched("projectAdmin", true, true);
                                    formik.setFieldValue(
                                        "projectAdmin",
                                        newValue ? newValue : {}
                                    );
                                    setExcludeFilterIds((prev) => {
                                        return [...prev.map((p) => {
                                            if (p.name === 'projectAdminId') {
                                                return { ...p }
                                            } else {
                                                return {
                                                    ...p,
                                                    value: [...p.value.filter((_v) => _v !== oldProjectAdminId), ...(newValue ? [newValue.id] : [])]
                                                }
                                            }
                                        })]
                                    })
                                }}
                                onBlur={() => {
                                    if (!formik.touched?.projectAdmin) {
                                        formik.setFieldTouched("projectAdmin", true, true);
                                    }
                                }}
                            />
                            {formik.touched.projectAdmin &&
                                formik.errors.projectAdmin && (
                                    <span className="text-danger">
                                        {formik.errors.projectAdmin}
                                    </span>
                                )}
                        </div> */}
                        {!isSpecificCompany && (
                            <><div className="col-sm-6 mb-3 plSelectTypeField pe-2">
                                <SearchDropDownListPaginationComponent
                                    label={t("Startup Owner") + " *"}
                                    disabled={projectCreationLoading}
                                    searchEnabled={false}
                                    defaultValue={Object.keys(formik.values.projectOwner).length !== 0 ? formik.values.projectOwner : undefined}
                                    disableClearable={!formik.values.projectOwner}
                                    listCall={getUserList}
                                    apiParams={{
                                        order: "firstName",
                                        direction: "desc",
                                        isActive: true,
                                        includeAdmins: false,
                                        ...(
                                            excludeFilterIds.find((ex) => ex.name === 'projectOwnerId').value?.length && {
                                                excludeFilterFields: "id",
                                                excludeFilterInputs: excludeFilterIds.find((ex) => ex.name === 'projectOwnerId').value.join(',')
                                            }
                                        )
                                    }}
                                    emitItem={(newValue) => {
                                        const oldProjectOwnerId = formik.values.projectOwner.id;
                                        formik.setFieldTouched("projectOwner", true, true);
                                        formik.setFieldValue(
                                            "projectOwner",
                                            newValue ? newValue : {}
                                        );
                                        setExcludeFilterIds((prev) => {
                                            return [...prev.map((p) => {
                                                if (p.name === 'projectOwnerId') {
                                                    return { ...p };
                                                } else {
                                                    return {
                                                        ...p,
                                                        value: [...p.value.filter((_v) => _v !== oldProjectOwnerId), ...(newValue ? [newValue.id] : [])]
                                                    };
                                                }
                                            })];
                                        });
                                    }}
                                    onBlur={() => {
                                        if (!formik.touched?.projectOwner) {
                                            formik.setFieldTouched("projectOwner", true, true);
                                        }
                                    }} />
                                {formik.touched.projectOwner &&
                                    formik.errors.projectOwner && (
                                        <span className="text-danger">
                                            {formik.errors.projectOwner}
                                        </span>
                                    )}
                            </div><div className="col-sm-6 mb-3 plSelectTypeField">
                                    <SearchDropDownListPaginationComponent
                                        label={t("Startup Sponsor") + " *"}
                                        disabled={projectCreationLoading}
                                        searchEnabled={false}
                                        defaultValue={Object.keys(formik.values.projectSponsor).length !== 0 ? formik.values.projectSponsor : undefined}
                                        disableClearable={!formik.values.projectSponsor}
                                        listCall={getUserList}
                                        apiParams={{
                                            order: "firstName",
                                            direction: "desc",
                                            isActive: true,
                                            includeAdmins: false,
                                            ...(
                                                excludeFilterIds.find((ex) => ex.name === 'projectSponsorId').value?.length !== 0 && {
                                                    excludeFilterFields: "id",
                                                    excludeFilterInputs: excludeFilterIds.find((ex) => ex.name === 'projectSponsorId').value.join(',')
                                                }
                                            )
                                        }}
                                        emitItem={(newValue) => {
                                            const oldProjectSponsorId = formik.values.projectSponsor.id;
                                            formik.setFieldTouched("projectSponsor", true, true);
                                            formik.setFieldValue(
                                                "projectSponsor",
                                                newValue ? newValue : {}
                                            );
                                            setExcludeFilterIds((prev) => {
                                                return [...(prev.map((p) => {
                                                    if (p.name === 'projectSponsorId') {
                                                        return { ...p };
                                                    } else {
                                                        return {
                                                            ...p,
                                                            value: [...p.value.filter((_v) => _v !== oldProjectSponsorId), ...(newValue ? [newValue.id] : [])]
                                                        };
                                                    }
                                                }))];
                                            });
                                        }}
                                        onBlur={() => {
                                            if (!formik.touched?.projectSponsor) {
                                                formik.setFieldTouched("projectSponsor", true, true);
                                            }
                                        }} />
                                    {formik.touched.projectSponsor &&
                                        formik.errors.projectSponsor && (
                                            <span className="text-danger">
                                                {formik.errors.projectSponsor}
                                            </span>
                                        )}
                                </div></>
                        )}
                        {isShow && (
                            <><div className="mb-3 plSelectTypeField">
                                <Autocomplete
                                    labelId="demo-simple-select-label"
                                    id="sector"
                                    name="sector"
                                    readOnly={isReadable}
                                    value={formik.values.sector}
                                    size="small"
                                    options={Object.values(TechnologySector)}
                                    getOptionLabel={(option) => option ? t(option) : ""}
                                    onChange={(e, newValue) => formik.setFieldValue('sector', newValue ? newValue : '')}
                                    onBlur={formik.handleBlur}
                                    renderInput={(params) => <TextField {...params}
                                        label={t("Technology Sector")+"*"} />} />
                                {formik.touched.sector && formik.errors.sector && (
                                    <span className="text-danger">{formik.errors.sector}</span>
                                )}
                            </div>
                                {/* <div className="mb-3 plSelectTypeField pe-2">
                                    <FormControl>
                                        <FormLabel id="demo-row-radio-buttons-group-label">{`${t("What is the official status of the project (Has the company been officially registered?)")} *`}</FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="isRegister"
                                            value={formik.values.isRegister}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        >
                                            <FormControlLabel value="yes" disabled={isReadable} control={<Radio />} label={t("Yes")} />
                                            <FormControlLabel value="no" disabled={isReadable} control={<Radio />} label={t("No")} />
                                        </RadioGroup>
                                        {formik.touched.isRegister && formik.errors.isRegister && (
                                            <span className="text-danger">{formik.errors.isRegister}</span>
                                        )}
                                    </FormControl>
                                </div> */}
                                <div className="col-sm-6 mb-3 plSelectTypeField pe-2">
                                    <TextField
                                        id="outlined-basic"
                                        inputProps={{
                                            readOnly: isReadable
                                        }}
                                        label={t("Provide the number of pending IP's")}
                                        variant="outlined"
                                        type="number"
                                        size="small"
                                        name="pendingIps"
                                        value={formik.values.pendingIps}
                                        disabled={projectCreationLoading}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        fullWidth />
                                    {formik.touched.pendingIps && formik.errors.pendingIps && (
                                        <span className="text-danger">{formik.errors.pendingIps}</span>
                                    )}
                                </div><div className="col-sm-6 mb-3 plSelectTypeField">
                                    <TextField
                                        id="outlined-basic"
                                        inputProps={{
                                            readOnly: isReadable
                                        }}
                                        label={t("Provide the number of granted IP's")}
                                        variant="outlined"
                                        type="number"
                                        size="small"
                                        name="grantedIps"
                                        value={formik.values.grantedIps}
                                        disabled={projectCreationLoading}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        fullWidth />
                                    {formik.touched.grantedIps && formik.errors.grantedIps && (
                                        <span className="text-danger">{formik.errors.grantedIps}</span>
                                    )}
                                </div><div className="col-sm-12 mb-3">
                                    <TextField
                                        id="outlined-basic"
                                        inputProps={{
                                            readOnly: isReadable
                                        }}
                                        label={t("Who are the potential customers (who could buy your service or product)?")}
                                        variant="outlined"
                                        type="text"
                                        size="small"
                                        name="customers"
                                        value={formik.values.customers}
                                        disabled={projectCreationLoading}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        fullWidth />
                                    {formik.touched.customers && formik.errors.customers && (
                                        <span className="text-danger">{formik.errors.customers}</span>
                                    )}
                                </div><div className="mb-3 plSelectTypeField pe-2">
                                    <FormControl>
                                        <FormLabel id="demo-row-radio-buttons-group-label">{t('Have you received any interest from potential customers?') + " *"}</FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="isPotentialCustomer"
                                            value={formik.values.isPotentialCustomer}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        >
                                            <FormControlLabel value="not_yet" disabled={isReadable} control={<Radio />} label={t("Not yet")} />
                                            <FormControlLabel value="yes_verbal" disabled={isReadable} control={<Radio />} label={t("Yes (verbal interest)")} />
                                            <FormControlLabel value="yes_written" disabled={isReadable} control={<Radio />} label={t("Yes (written agreement or paid customer)")} />
                                            <FormControlLabel value="other" disabled={isReadable} control={<Radio />} label={t("Other")} />
                                        </RadioGroup>
                                        {formik.touched.isPotentialCustomer && formik.errors.isPotentialCustomer && (
                                            <span className="text-danger">{formik.errors.isPotentialCustomer}</span>
                                        )}
                                    </FormControl>
                                    {formik.values.isPotentialCustomer === 'other' && (
                                        <div className="col-sm-12 mb-3">
                                            <TextField
                                                id="outlined-basic"
                                                inputProps={{
                                                    readOnly: isReadable
                                                }}
                                                label={t("Please type your answer")}
                                                variant="outlined"
                                                type="text"
                                                size="small"
                                                name="isOtherPotential"
                                                value={formik.values.isOtherPotential}
                                                disabled={projectCreationLoading}
                                                onChange={formik.handleChange}
                                                fullWidth />
                                            {formik.touched.isOtherPotential && formik.errors.isOtherPotential && (
                                                <span className="text-danger">{formik.errors.isOtherPotential}</span>
                                            )}
                                        </div>
                                    )}
                                </div><div className="mb-3 plSelectTypeField pe-2">
                                    <FormControl>
                                        <FormLabel id="demo-controlled-radio-buttons-group">{t('Based on the Technology Readiness Levels (TRL), where does your startup stand?') + " *"}</FormLabel>
                                        <RadioGroup
                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                            name="isTRL"
                                            value={formik.values.isTRL}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        >
                                            <FormControlLabel value="trl1" disabled={isReadable} control={<Radio />} label={t("TRL1 (Research: Basic principles observed)")} />
                                            <FormControlLabel value="trl2" disabled={isReadable} control={<Radio />} label={t("TRL2 (Research: Technology concept formulated)")} />
                                            <FormControlLabel value="trl3" disabled={isReadable} control={<Radio />} label={t("TRL3 (Research: Experimental proof of concept)")} />
                                            <FormControlLabel value="trl4" disabled={isReadable} control={<Radio />} label={t("TR4 (Development: Technology validated in lab)")} />
                                            <FormControlLabel value="trl5" disabled={isReadable} control={<Radio />} label={t("TRL5 (Development: Technology validated in relevant environment))")} />
                                            <FormControlLabel value="trl6" disabled={isReadable} control={<Radio />} label={t("TRL6 (Development: Technology demonstrated in relevant environment)")} />
                                            <FormControlLabel value="trl7" disabled={isReadable} control={<Radio />} label={t("TRL7 (Deployment: System model or prototype demonstration in operational environment)")} />
                                            <FormControlLabel value="trl8" disabled={isReadable} control={<Radio />} label={t("TRL8 (Deployment: System complete and qualified)")} />
                                            <FormControlLabel value="trl9" disabled={isReadable} control={<Radio />} label={t("TRL9 (Deployment: Actual system proven in operational environment)")} />
                                        </RadioGroup>
                                        {formik.touched.isTRL && formik.errors.isTRL && (
                                            <span className="text-danger">{formik.errors.isTRL}</span>
                                        )}
                                    </FormControl>
                                </div>
                                {/* <div className="col-sm-12 mb-3">
                                    <TextField
                                        id="outlined-basic"
                                        label={t("Sales Platform or Website")}
                                        variant="outlined"
                                        inputProps={{
                                            readOnly: isReadable
                                        }}
                                        type="text"
                                        size="small"
                                        name="salePlatform"
                                        value={formik.values.salePlatform}
                                        disabled={projectCreationLoading}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        fullWidth />
                                    {formik.touched.salePlatform && formik.errors.salePlatform && (
                                        <span className="text-danger">{formik.errors.salePlatform}</span>
                                    )}
                                </div> */}
                                {/* <div className="col-sm-12 mb-3">
                                    <TextField
                                        id="outlined-basic"
                                        label={t("How do you plan to generate revenue?")}
                                        variant="outlined"
                                        inputProps={{
                                            readOnly: isReadable
                                        }}
                                        type="text"
                                        size="small"
                                        name="planRevenue"
                                        value={formik.values.planRevenue}
                                        disabled={projectCreationLoading}
                                        onChange={formik.handleChange}
                                        fullWidth />
                                </div> */}
                                <div className="mb-3 plSelectTypeField pe-2">
                                    <FormControl>
                                        <FormLabel id="demo-row-radio-buttons-group-label">{t('Are there any approval requirements needed? (E.g.: Saudi FDA approval)')}</FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="isApproval"
                                            value={formik.values.isApproval}
                                            onChange={formik.handleChange}
                                        >
                                            <FormControlLabel value="yes" disabled={isReadable} control={<Radio />} label={t("Yes")} />
                                            <FormControlLabel value="no" disabled={isReadable} control={<Radio />} label={t("No")} />
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                                {/* <div className="mb-3 plSelectTypeField pe-2">
                                    <FormControl>
                                        <FormLabel id="demo-row-radio-buttons-group-label">{t('Have you conducted financial analysis or projections?') + " *"}</FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="analysis"
                                            value={formik.values.analysis}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        >
                                            <FormControlLabel disabled={isReadable} value="yes" control={<Radio />} label={t("Yes")} />
                                            <FormControlLabel value="no" disabled={isReadable} control={<Radio />} label={t("No")} />
                                            <FormControlLabel value="other" disabled={isReadable} control={<Radio />} label={t("Other")} />
                                        </RadioGroup>
                                        {formik.touched.analysis && formik.errors.analysis && (
                                            <span className="text-danger">{formik.errors.analysis}</span>
                                        )}
                                    </FormControl>
                                    {formik.values.analysis === 'other' && (
                                        <div className="col-sm-12 mb-3">
                                            <TextField
                                                id="outlined-basic"
                                                label={t("Please type your answer")}
                                                variant="outlined"
                                                type="text"
                                                size="small"
                                                inputProps={{
                                                    readOnly: isReadable
                                                }}
                                                name="analysisOther"
                                                value={formik.values.analysisOther}
                                                disabled={projectCreationLoading}
                                                onChange={formik.handleChange}
                                                fullWidth />
                                            {formik.touched.analysisOther && formik.errors.analysisOther && (
                                                <span className="text-danger">{formik.errors.analysisOther}</span>
                                            )}
                                        </div>
                                    )}
                                </div> */}
                                {/* <div className="mb-3 plSelectTypeField pe-2">
                                    <FormControl>
                                        <FormLabel id="demo-row-radio-buttons-group-label">{t('Are you currently raising fund or looking for investments?') + " *"}</FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="isInvestor"
                                            value={formik.values.isInvestor}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        >
                                            <FormControlLabel value="yes" disabled={isReadable} control={<Radio />} label={t("Yes")} />
                                            <FormControlLabel value="no" disabled={isReadable} control={<Radio />} label={t("No")} />
                                        </RadioGroup>
                                        {formik.touched.isInvestor && formik.errors.isInvestor && (
                                            <span className="text-danger">{formik.errors.isInvestor}</span>
                                        )}
                                    </FormControl>
                                </div> */}
                                <div className="mb-3 plSelectTypeField pe-2">
                                    <FormControl>
                                        <FormLabel id="demo-row-radio-buttons-group-label">{t('If you are looking for investments, at which funding stage is your startup?')} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="fundStage"
                                            value={formik.values.fundStage}
                                            onChange={formik.handleChange}
                                        >
                                            <FormControlLabel value="stage1" disabled={isReadable} control={<Radio />} label={t("Stage1: Idea")} />
                                            <FormControlLabel value="stage2" disabled={isReadable} control={<Radio />} label={t("Stage2: Pre-seed (Obtained initial funding to build the product or Minimum Viable Product (MVP))")} />
                                            <FormControlLabel value="stage3" disabled={isReadable} control={<Radio />} label={t("Stage3: Seed (Initial stage of equity funding used to support the early development and growth of a startup)")} />
                                            <FormControlLabel value="stage4" disabled={isReadable} control={<Radio />} label={t("Stage4: Series A and above")} />
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                                {/* <div className="col-sm-12 mb-3">
                                    <TextField
                                        id="outlined-basic"
                                        label={t("List all interested investors you have approached?")}
                                        variant="outlined"
                                        inputProps={{
                                            readOnly: isReadable
                                        }}
                                        type="text"
                                        size="small"
                                        name="investors"
                                        value={formik.values.investors}
                                        disabled={projectCreationLoading}
                                        onChange={formik.handleChange}
                                        fullWidth />
                                </div> */}

                                {/* <div className="col-sm-12 mb-3">
                                    <TextField
                                        variant="outlined"
                                        minimumValue="0"
                                        decimalPlaces={2}
                                        name="invesmentAmount"
                                        inputProps={{
                                            readOnly: isReadable
                                        }}
                                        value={formik.values.invesmentAmount}
                                        currencySymbol="SAR"
                                        fullWidth
                                        placeholder={t("Give an estimate of the amount of investment you are seeking in SAR.")}
                                        required
                                        disabled={projectCreationLoading}
                                        onChange={(e, newValue) => {
                                            formik.setFieldValue('invesmentAmount', newValue === 0 ? '' : newValue, true);
                                        }}
                                        onBlur={() => {
                                            formik.setFieldTouched('invesmentAmount', true, true);
                                        }} />
                                    {formik.touched.invesmentAmount && formik.errors.invesmentAmount && (
                                        <span className="text-danger">{formik.errors.invesmentAmount}</span>
                                    )}
                                </div> */}

                                {/* <div className="col-sm-12 mb-3">
                                    <TextField
                                        fullWidth
                                        className="form-control"
                                        id="project-title-input"
                                        label={t("Progress Update")}
                                        inputProps={{
                                            readOnly: isReadable
                                        }}
                                        name="progressDesc"
                                        value={formik.values.progressDesc}
                                        disabled={projectCreationLoading}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        onFocus={() => {
                                            if (!formik.touched?.progressDesc) {
                                                formik.setFieldTouched("progressDesc", true, true);
                                            }
                                        }}
                                        multiline
                                        rows={4} />
                                    <div>
                                        {formik.touched.progressDesc && formik.errors.progressDesc && (
                                            <span className="text-danger">{formik.errors.progressDesc}</span>
                                        )}
                                    </div>
                                </div> */}
                                {/* <div className="col-sm-12 mb-3">
                                    <TextField
                                        fullWidth
                                        className="form-control"
                                        id="project-title-input"
                                        inputProps={{
                                            readOnly: isReadable
                                        }}
                                        label={t("Upcoming Update")}
                                        name="upcomingDesc"
                                        value={formik.values.upcomingDesc}
                                        disabled={projectCreationLoading}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        onFocus={() => {
                                            if (!formik.touched?.upcomingDesc) {
                                                formik.setFieldTouched("upcomingDesc", true, true);
                                            }
                                        }}
                                        multiline
                                        rows={4} />
                                    <div>
                                        {formik.touched.upcomingDesc && formik.errors.upcomingDesc && (
                                            <span className="text-danger">{formik.errors.upcomingDesc}</span>
                                        )}
                                    </div>
                                </div> */}
                                {/* <div className="col-sm-12 mb-3 plSelectTypeField pe-2">
                                    <TextField
                                        id="outlined-basic"
                                        label={t("Market Size")}
                                        variant="outlined"
                                        inputProps={{
                                            readOnly: isReadable
                                        }}
                                        type="text"
                                        size="small"
                                        name="marketSize"
                                        value={formik.values.marketSize}
                                        disabled={projectCreationLoading}
                                        onChange={formik.handleChange}
                                        fullWidth />
                                </div> */}
                                {/* <div className="col-sm-12 mb-3 plSelectTypeField">
                                    <TextField
                                        id="outlined-basic"
                                        label={t("What is the total revenue of the company?")}
                                        inputProps={{
                                            readOnly: isReadable
                                        }}
                                        variant="outlined"
                                        type="number"
                                        size="small"
                                        name="revenue"
                                        value={formik.values.revenue}
                                        disabled={projectCreationLoading}
                                        onChange={formik.handleChange}
                                        fullWidth />
                                </div> */}

                                {/* <div className="col-sm-12 mb-3 plSelectTypeField">
                                    <TextField
                                        id="outlined-basic"
                                        label={t("What is the total valuation of your company?")}
                                        inputProps={{
                                            readOnly: isReadable
                                        }}
                                        variant="outlined"
                                        type="number"
                                        size="small"
                                        name="valuation"
                                        value={formik.values.valuation}
                                        disabled={projectCreationLoading}
                                        onChange={formik.handleChange}
                                        fullWidth />
                                </div> */}

                                {/* <div className="col-sm-12 mb-3 plSelectTypeField">
                                    <TextField
                                        id="outlined-basic"
                                        label={t("How many jobs were created in your startup?")}
                                        inputProps={{
                                            readOnly: isReadable
                                        }}
                                        variant="outlined"
                                        type="number"
                                        size="small"
                                        name="jobs"
                                        min="0"
                                        value={formik.values.jobs}
                                        disabled={projectCreationLoading}
                                        onChange={formik.handleChange}
                                        fullWidth />
                                </div> */}
                                <div className="row mb-3">
                                    <div className="col-md-9 col-12">
                                        <span className="mb-2">{t("Please attach the latest pitch deck presentation in PDF format (Uploaded Pitchdeck will be publicly available for download) *")}</span>
                                    </div>
                                    <div
                                        key={update}
                                        className="col-md-3 col-12 fileUpload"
                                        style={{ position: "relative", justifyContent: 'center' }}
                                    >
                                        <div className="globalAttachmentBrowse position-relative">
                                            <AttachFile
                                                className="attachment_button"
                                                style={isReadable ? { cursor: 'not-allowed' } : { cursor: 'pointer' }} />
                                            <span className="mx-2">{t("Upload")}</span>
                                            <input
                                                type="file"
                                                disabled={isReadable}
                                                accept={'.pdf'}
                                                name="presentationDocs"
                                                onChange={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    selectedProjectRow?.id ? handleLogoUpload(e.target.files[0]) : handelChange(e);
                                                }}
                                                className="browse_attachment_inpt" />
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-12  d-grid globalAttachmentList">
                                        {presentationDocsLoader && <Loader />}
                                        {formik.values?.presentationDocs && (
                                            <>
                                                <div className='singleAttachment'>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className="attachmentFileIcon">
                                                            <DescriptionOutlinedIcon />
                                                        </div>
                                                        <span className='me-3 fs-6 fw-semibold text-truncate' style={{
                                                            width: '180px', display: 'inline-block'
                                                        }}>{formik.values?.presentationDocs?.name} </span>
                                                        <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                                                            setModal(true);
                                                            setFilePath(selectedProjectRow?.id ? getUrl(formik.values.presentationDocs.storageLink) : formik.values?.presentationDocs?.location);
                                                            setFileName(formik.values?.presentationDocs?.name);
                                                        }} />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div></>
                        )}
                    </div>
                    {action !== Action.VIEW && (
                        <div className="plsubmitButton">
                            <Button
                                className="btn addNew_ProjectBtn"
                                disabled={projectCreationLoading || !formik.isValid || !formik.values.portfolios?.id}
                                type="submit"
                                onClick={action === Action.EDIT ? handleEdit : handleCreate}
                            >
                                {projectCreationLoading && (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-1"
                                    />
                                )}
                                {t('Submit')}
                            </Button>
                        </div>
                    )}
                </form>
            </Drawer>
            {
                isOpenSweetAlert && (
                    <SweetAlert
                        title={`Are you sure want to delete this ${documentUploadType === Modules.PROJECT ? 'startup document' : 'logo'}?`}
                        warning
                        showCancel
                        confirmButtonText="Yes, delete it!"
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => {
                            if (documentUploadType === Modules.PROJECT) {
                                selectedProjectRow?.id ? handelDelete() : removeFile()
                            } else {
                                formik.setFieldValue('logo', '')
                                setIsOpenSweetAlert(false)
                            }
                        }}
                        onCancel={() => {
                            setIsOpenSweetAlert(false)
                            setDocumentUploadType()
                        }}>
                    </SweetAlert>
                )
            }

            {
                modal && (
                    <DocumentFilePreviewModal isLocal={selectedProjectRow?.id ? false : true} modal={modal} setModal={setModal} filePath={filePath} fileName={fileName} />
                )
            }
        </div>
    );
};

export default withTranslation()(AddProjectDrawer);
